
import React from 'react';
import { cn } from '@/lib/utils';

export interface SidebarMenuProps extends React.HTMLAttributes<HTMLUListElement> {}

export const SidebarMenu = React.forwardRef<HTMLUListElement, SidebarMenuProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <ul
        ref={ref}
        className={cn('space-y-1 p-2', className)}
        {...props}
      >
        {children}
      </ul>
    );
  }
);
SidebarMenu.displayName = 'SidebarMenu';
